import { gql } from "@apollo/client";

export const getBuildingStructureForTelefonBox = gql`
  query getBuildingStructureForTelefonBox(
    $areaType: AreaTypeEnum
    $buildingId: ID!
    $date: Date!
    $start: DateTime
    $end: DateTime
  ) {
    building(buildingId: $buildingId) {
      id
      name
      image
      address
      numberOfTelefonBoxes
      floors {
        id
        floorLabel
        floorNumber
        floorType
        areas(areaType: $areaType) {
          id
          areaType
          image
          name
          isBookable
          isTelefonBoxFree(start: $start, end: $end)
          telefonBoxTimeStats(date: $date) {
            booked
            total
          }
          equipment {
            category {
              id
              name
            }
            id
            name
          }
        }
        telefonBoxTimeStats(date: $date) {
          booked
          total
        }
      }
    }
  }
`;
